export default {

    sendSmsOrEmail: {
        url: 'sendOffer',
        method: 'post',
    },

    getDebtsBoticarioAndEudora: {
        url: 'boticario-eudora/debts',
        method: 'post',
    },

    viewOffersBoticarioAndEudora: {
        url: 'boticario-eudora/viewOffers',
        method: 'post',
    },

    paymentActionBoticarioAndEudora: {
        url: 'boticario-eudora/paymentAction',
        method: 'post',
    },

    agreementBoticarioAndEudora: {
        url: 'boticario-eudora/agreement',
        method: 'post',
        // Resposta PIX pode ser grande / lenta em redes móveis; evita falso negativo por timeout do cliente.
        timeout: 120000,
    },

    sendEmailOrWhatsapp: {
        url: 'boticario-eudora/sendAgreement',
        method: 'post',
    },

}
